import { Accordion } from '../../modules/accordion.js';

window.app = window.app || {};
app.ui = app.ui || {};


app.ui.accordion = () => {
    document.querySelectorAll('.accordion').forEach(accordion => new Accordion({
        accordion: accordion,
        singleItem: true,
        allowDeeplinking: true,
        on: {
            close: (c) => app.site.controls.stop(c),
            open: (c) => {
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 50)
            }
        }
    }));
};
